import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchDropdown = _resolveComponent("SearchDropdown")!
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: ['CampaignEditorRow'],
    isLoading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
        _createElementVNode("label", {
          class: "CampaignEditorInputLabel DropdownLabel",
          for: "OrganisationLinkingSearchBar"
        }, " Search for an organisation ")
      ], -1 /* CACHED */)),
      (_openBlock(), _createElementBlock("div", {
        ref: "searchWrapper",
        class: "CampaignEditorRightColumn",
        key: _ctx.linkedOrganisationsAsString
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "PreInputFieldIcon lnr-magnifier" }, null, -1 /* CACHED */)),
        _createElementVNode("input", {
          id: "OrganisationLinkingSearchBar",
          class: "CampaignEditorInputField",
          type: "text",
          ref: "searchInput",
          placeholder: "Search by organisation name / ID",
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setSearchTerm && _ctx.setSearchTerm(...args))),
          onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.revealDropdown && _ctx.revealDropdown(...args)))
        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
        (_ctx.showDropdown)
          ? (_openBlock(), _createBlock(_component_SearchDropdown, {
              key: _ctx.searchResultsAsString,
              searchTerm: _ctx.searchTerm,
              items: _ctx.searchResults,
              showSpinner: _ctx.showSpinner
            }, null, 8 /* PROPS */, ["searchTerm", "items", "showSpinner"]))
          : _createCommentVNode("v-if", true)
      ]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["isLoading"]))
}